import { render, staticRenderFns } from "./basic.md?vue&type=template&id=08ab8e8c&"
import script from "./basic.md?vue&type=script&lang=js&"
export * from "./basic.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08ab8e8c')) {
      api.createRecord('08ab8e8c', component.options)
    } else {
      api.reload('08ab8e8c', component.options)
    }
    module.hot.accept("./basic.md?vue&type=template&id=08ab8e8c&", function () {
      api.rerender('08ab8e8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Wave/basic.md"
export default component.exports